import React from "react"
import img from "../../icons/attention.png";
 const image =()=>{
    return (
     <img src={img} alt="compartment" />
    )
}
export default image
 


// WEBPACK FOOTER //
// ./src/UI/Image/ImageCompartment.js